/**
 * @fileoverview Compile-time UI feature toggles. Not loaded from a remote flag service;
 * change values here and redeploy. Prefer {@link FeatureFlags} keys named `enable*` or `show*`
 * so `true` consistently means "on".
 */

/**
 * @typedef {Object} FeatureFlags
 * @property {boolean} enableUserGuide If true, the nav User Guide link can render when
 *   static data includes a `userGuide` URL (see Vuex `simpleData`). If false, the link
 *   never appears.
 * @property {boolean} showProfileBillingSection If true, show Billing card on Profile page.
 * @property {boolean} showProfileApiSection If true, show API card on Profile page.
 */

/**
 * Default feature flag values for the app shell and shared UI.
 *
 * @type {FeatureFlags}
 */
export const FEATURE_FLAGS = {
  enableUserGuide: false,
  showProfileBillingSection: false,
  showProfileApiSection: false,
};
